import { render, staticRenderFns } from "./CategoryEditDialog.vue?vue&type=template&id=380b31ff&scoped=true&"
import script from "./CategoryEditDialog.vue?vue&type=script&lang=js&"
export * from "./CategoryEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380b31ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
